export default "__VITE_ASSET__0pFqINQg__"